// removed by extract-text-webpack-plugin
module.exports = {"carousel":"qempo_CarouselItems_carousel-2rxE19N","b":"qempo_CarouselItems_b-22hiBJ4","arrowLeft":"qempo_CarouselItems_arrowLeft-1T_Hgj7","arrowRight":"qempo_CarouselItems_arrowRight-2y5u05L","dots":"qempo_CarouselItems_dots-25BLu_m"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/CarouselItems/CarouselItems.scss
// module id = 1974
// module chunks = 0